// components/profesionales/MetodoCobro/index.js
import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import './MetodoCobro.css'

function MetodoCobro({ datos }) {
	// Ajuste: datos ahora es un array, tomamos el primer elemento si existe
	const metodoCobro = Array.isArray(datos) && datos.length > 0 ? datos[0] : null;

	if (!metodoCobro) {
		return (
			<Alert variant="info">No hay información sobre el método de cobro</Alert>
		)
	}

	// Determinar el tipo de método basado en el nombre
	const esMetodoBancario = metodoCobro.nombre === 'Cuenta bancaria'

	return (
		<Container fluid className="metodo-cobro-container">
			<Row>
				<Col>
					<Card>
						<Card.Header className={esMetodoBancario ? 'header-banco' : 'header-telefonia'}>
							<div className="d-flex align-items-center">
								<i className={`fa ${esMetodoBancario ? 'fa-university' : 'fa-mobile-alt'} me-2`}></i>
								<h5 className="mb-0">{metodoCobro.nombre || 'Método de cobro'}</h5>
							</div>
						</Card.Header>
						<Card.Body>
							<Table striped bordered hover responsive>
								<tbody>
									<tr>
										<th width="30%">Titular</th>
										<td>{metodoCobro.titular || <span className="text-muted">No especificado</span>}</td>
									</tr>
									<tr>
										<th>CI del titular</th>
										<td>{metodoCobro.ci || <span className="text-muted">No especificado</span>}</td>
									</tr>
									{metodoCobro.entidad && (
										<tr>
											<th>{esMetodoBancario ? 'Banco' : 'Operador'}</th>
											<td>{metodoCobro.entidad}</td>
										</tr>
									)}
									{metodoCobro.numero && (
										<tr>
											<th>{esMetodoBancario ? 'Número de cuenta' : 'Número de teléfono'}</th>
											<td>{metodoCobro.numero}</td>
										</tr>
									)}
								</tbody>
							</Table>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}

export default MetodoCobro